export const APP_VERSION = '1.11.1'; // updated automatically in build script
export const ERROR_RATE_PERCENTAGE = 10;
